import { gql } from '@apollo/client';

const getSurveyAnalyticsByCourseQuery = gql`
  query getSurveyAnalyticsByCourse($course: MongoID!, $courseCategory: MongoID, $student: MongoID!) {
    getSurveyAnalyticsByCourse(course: $course, courseCategory: $courseCategory, student: $student)
  }
`;

export default getSurveyAnalyticsByCourseQuery;
